(() => {
  const enhance = (root = document) => {
    root.querySelectorAll('.product-information').forEach(section => {
      const card=section.querySelector('[data-kaya-details]');
      if(!card)return;
      const original=section.querySelector('.product-details .kaya-product-description');
      if(original)original.remove();
      const specs=section.querySelector('.product-details kaya-product-specifications');
      if(specs)card.querySelector('.kaya-details-extra').append(specs);
    });
    root.querySelectorAll('.kaya-product-copy, .kaya-product-description__content, [data-testid="product-description"] .rte').forEach(copy => {
      if(copy.dataset.enhanced)return;
      copy.dataset.enhanced='true';copy.classList.add('kaya-product-copy');
      copy.querySelectorAll('ul').forEach(list => {
        const rows=[...list.children];
        if(rows.length<2||!rows.every(row=>row.querySelector('strong')))return;
        const dl=document.createElement('dl');dl.className='kaya-spec-grid';
        rows.forEach(row=>{const strong=row.querySelector('strong'),item=document.createElement('div'),term=document.createElement('dt'),value=document.createElement('dd');term.textContent=strong.textContent.replace(/:\s*$/,'');const clone=row.cloneNode(true);clone.querySelector('strong').remove();value.textContent=clone.textContent.trim();item.append(term,value);dl.append(item);});
        list.replaceWith(dl);
      });
      copy.querySelectorAll('table').forEach(table=>{
        table.classList.add('kaya-spec-table');const headers=[...table.querySelectorAll('thead th')].map(h=>h.textContent.trim());
        if(headers.length>3){table.classList.add('kaya-spec-table--variants');table.querySelectorAll('tbody tr').forEach(row=>[...row.children].forEach((cell,i)=>cell.dataset.label=headers[i]||''));}
        const wrap=document.createElement('div');wrap.className='kaya-table-wrap';table.before(wrap);wrap.append(table);
      });
    });
  };
  enhance();document.addEventListener('shopify:section:load',e=>enhance(e.target));
})();
